import {Pipe,PipeTransform} from '@angular/core';
import {discountedPrice} from '../../../shared/price';

@Pipe({name:'discountedPrice'})
export class DiscountedPricePipe implements PipeTransform{
	transform(price:number,discountPercent?:number|null,quantity=1):number{
		return discountedPrice(price,discountPercent,quantity);
	}
}
